import { useState } from 'react'
import { signIn } from 'next-auth/client'
import { useRouter } from 'next/router'
import Form from 'components/form/form'

export default function LoginForm({ passwordContent, redirect }) {
    const router = useRouter()
    const [error, setError] = useState()
    const callbackUrl = router.query.r || redirect || '/'

    const submitHandler = async data => {
        console.log('login start');
        const result = await signIn('credentials', { ...data, redirect: false })
        console.log(result);
        if (result && result.error) {
            setError(result.error)
        } else if (result && result.data && result.data.error) {
            setError(result.data.error)
        } else {
            window.location.href = callbackUrl
        }
    }

    const props = {
        onSubmit: submitHandler,
        submitProps: { block: 1 },
        noAsterisk: true,
        submitText: 'Prisijungti',
        fields: [
            {
                name: 'email',
                type: 'email',
                label: 'Jūsų el. pašto adresas',
                value: '',
                required: true
            },
            {
                name: 'password',
                type: 'password',
                label: 'Slaptažodis',
                content: passwordContent,
                value: '',
                required: true
            }
        ]
    }

    return <Form {...props} error={error} />
}
